import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var NativeColorPicker = /*#__PURE__*/function (_Vue) {
  function NativeColorPicker() {
    var _this;
    _classCallCheck(this, NativeColorPicker);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, NativeColorPicker, [].concat(args));
    _defineProperty(_this, "defaultColor", null);
    _defineProperty(_this, "width", void 0);
    _defineProperty(_this, "selectedColor", '');
    return _this;
  }
  _inherits(NativeColorPicker, _Vue);
  return _createClass(NativeColorPicker, [{
    key: "mounted",
    value: function mounted() {
      this.selectedColor = this.defaultColor;
    }
  }, {
    key: "selectAColor",
    value: function selectAColor(color) {
      this.selectedColor = color;
      this.$emit('onSelection', this.selectedColor);
    }
  }, {
    key: "onColorInputChanges",
    value: function onColorInputChanges(color) {
      this.selectedColor = color.target.value;
    }
  }, {
    key: "updateSelectedColor",
    value: function updateSelectedColor(color) {
      this.selectedColor = color;
    }
  }, {
    key: "onBlur",
    value: function onBlur() {
      this.selectAColor(this.selectedColor);
    }
  }]);
}(Vue);
__decorate([Prop()], NativeColorPicker.prototype, "defaultColor", void 0);
__decorate([Prop({
  default: '160px'
})], NativeColorPicker.prototype, "width", void 0);
NativeColorPicker = __decorate([Options({
  watch: {
    defaultColor: function defaultColor() {
      this.selectedColor = this.defaultColor;
    }
  }
})], NativeColorPicker);
export default NativeColorPicker;